<template>
    <div class="cost-wrap">
        <div class="menu-wrap">
            <el-form :inline="true" >
                <el-form-item label="开始时间">
                    <!--日期-->
                    <el-date-picker
                    v-model="start_date"
                    type="date"
                    class="start_date date-input"
                    placeholder="开始日期"
                    @change="timeChange">
                    </el-date-picker>
                    <!--时间-->
                    <el-time-select
                    v-model="start_time"
                    class="start_time time-input"
                    placeholder="请选择"
                    @change="timeChange">
                    </el-time-select>
                </el-form-item>
        
                <el-form-item label="结束时间">
                    <!--日期-->
                    <el-date-picker
                    v-model="end_date"
                    type="date"
                    class="end_date date-input"
                    placeholder="开始日期"
                    @change="timeChange">
                    </el-date-picker>
                    <!--时间-->
                    <el-time-select
                    v-model="end_time"
                    class="end_time time-input"
                    placeholder="请选择"
                    @change="timeChange">
                    </el-time-select>
                </el-form-item>

                <el-form-item label="选择预设时间">
                    <el-select placeholder="预设时间" v-model="time_range" class="time_range" @change="timeRangeChange">
                        <el-option label="自定义" value="customize"></el-option>
                        <el-option label="最近一天" value="day"></el-option>
                        <el-option label="最近一周" value="week"></el-option>
                        <el-option label="最近一月" value="month"></el-option>
                        <el-option label="最近一年" value="year"></el-option>
                    </el-select>
                </el-form-item>
                
                <el-button plain type="primary" class="menu-btn" @click="searchData()">
                    查询
                </el-button>
                <el-button plain type="primary" class="menu-btn" @click="showSitesSelect">
                    站点筛选
                </el-button>

                <!--数据导出-->
                <download-excel 
                    class = "export-excel-wrapper"
                    :data = "pricelist"
                    :before-generate="exportFile"
                    :fields = "priceFileds"
                    :header="priceHeader"
                    :name = "priceFileName">
                    <el-button plain type="primary" class="menu-btn">
                        导出
                    </el-button>
                </download-excel>

                <el-button plain type="primary" class="menu-btn" @click="rechargeTypeChange('price')">
                    单价调整
                </el-button>
            </el-form>
            
        </div>
        
        <!--单价修改记录-->
        <div class="record">
             <el-table
                :data="pricelist"
                border
                :header-cell-style="{
                    background: 'rgba(78,132,255,1)',
                    color: 'white',
                    textAlign: 'center',
                }"
                :max-height="tableHeight"
                class="record-table"
                style="width: 100%">

                <el-table-column
                    prop="siteno"
                    width="120px"
                    label="站点编号">
                </el-table-column>

                <el-table-column
                    label="站点名称">
                    <template slot-scope="scope">
                        <span>{{ sitesList[scope.row.siteno].sitename }}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    width="250px"
                    prop="order_no"
                    label="订单编号">
                </el-table-column>
                <el-table-column
                    prop="price"
                    label="调整后单价">
                </el-table-column>
                <el-table-column
                    prop="create_time"
                    width="110"
                    label="操作时间">
                </el-table-column>

                <el-table-column
                    prop="statusstr"
                    label="操作结果">
                </el-table-column>

                <el-table-column
                    label="操作人">
                    <template slot-scope="scope">
                        <span v-if="userList&&userList[scope.row.operator]">{{userList[scope.row.operator].UserRealName}}</span>
                    </template>
                </el-table-column>
                
                <el-table-column
                    width="110"
                    prop="update_time"
                    label="状态更新时间">
                </el-table-column>
                

                <el-table-column
                    width="110"
                    label="定时时间">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.task_time">立即修改</span>
                        <span v-else>{{scope.row.task_time}}</span>
                    </template>
                </el-table-column>

                <!--操作-->
                <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                        <span v-if="diffTimeNow(scope.row.task_time)&&scope.row.operating_state==0" style="color:#409EFF;cursor: pointer;" @click="cancelChange(scope.row)">取消任务</span>
                        <span v-if="!diffTimeNow(scope.row.task_time)&&scope.row.operating_state==0">命令已创建</span>
                        <span v-if="scope.row.operating_state==1">操作进行中</span>
                        <span v-if="scope.row.operating_state==2">操作已完成</span>
                        <span v-if="scope.row.operating_state==3">操作已取消</span>
                    </template>
                </el-table-column>

            </el-table>
            <!--分页-->
            <el-pagination
                v-if="pricepage.total>0"
                @size-change="handlePriceSizeChange"
                @current-change="handlePriceCurrentChange"
                :current-page="pricepage.current"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="pricepage.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pricepage.total"
                class="pagination">
            </el-pagination>
        </div>

        <!-- 单价调整对话框 -->
        <el-dialog
            :visible.sync="rechargeDialog"
            :append-to-body='true'
            :modal="false"
            class="bill-dialog">
            <div slot="title">
                <span>单价调整</span>
            </div>

            <pricechange @update="priceHandle" />

        </el-dialog>

        <!-- 站点筛选--dialog -->
        <siteselect :show.sync="sitesDialog" v-if="sites&&sites.siteList" v-on:siteSelectCompleted="siteSelectCompleted"></siteselect>
    </div>
</template>
<script>
// 导出excel组件
import JsonExcel from "@lib/JsonExcel.js";

import {getPriceRecord,getDatabaseUser,canelPriceChange} from "@api/billing";

export default {
    name:"cose",
    data(){
        return {
            rechargeDialog:false, // 充值对话框

            pricelist: [], // 充值记录
            pricepage:{
                current:1,
                size:10,
                total:0,
            }, // 单价分页信息

            tableHeight:600, // 表格高度

            // 站点分组级联选择内容
            sitesList:{}, // 站点名称和编号列表
            site_list:'', // 选中站点列表
            sites: null, // 站点数据，包括站点mediumList、siteLevel、groupList、siteList
            sitesDialog:false, // 站点筛选对话框

            start_date:'', //开始日期
            end_date:'', // 结束日期
            start_time:'', // 开始时间
            end_time:'', // 结束时间
            time_range:"day", // 时间范围下拉框


            rechargeFileName:"充值记录.xls", // 导出文件的名称
            rechargeHeader:"", // 导出表头
            rechargeFileds:{
                "站点编号":"siteno",
                "站点名称":{
                    field: "siteno",
                    callback: (value) => {
                        return this.sitesList[value].sitename;
                    },
                },
                "订单编号":"order_no",
                '单价':"price",
                "充值金额(元)":"amount",
                "操作时间":"create_time",
                "充值前余额(元)":"old_amount",
                "充值后余额(元)":"remaining_amount",
                "剩余流量":"remaining_flux",
            },// 充值记录导出字段

            priceFileName:"单价修改记录.xls", // 单价修改文件名称
            priceHeader:"", // 导出表头
            priceFileds:{
                "站点编号":"siteno",
                "站点名称":{
                    field: "siteno",
                    callback: (value) => {
                        return this.sitesList[value].sitename;
                    },
                },
                "订单编号":"order_no",
                '调整后单价':"price",
                "调整时间":"create_time",
                "上一次单价":"old_price",
                "上一次操作时间":"old_time",
            }, // 单价导出字段

            userList:null, // 用户列表
        }
    },
    computed:{
        // 站点数据
        sites_config(){
            return this.$store.getters.getSitesConfigByPage();
        },

        // 用户信息
        userinfo(){
            return this.$store.state.user;
        },
    },
    components: {
        'downloadExcel':JsonExcel,
        siteselect: ()=>import("@components/SiteSelect"), // 站点筛选
        pricechange:()=>import("./PriceChange.vue"), // 单价调整
    },
    // components: { countTo },
    mounted(){
        this.$nextTick(()=>{
            this.init();

            // 获取数据库中可选的站点列表
            this.getSiteGroup();
            // 获取用户列表
            this.getUserList();

            // 监听数据刷新接口
            this.$bus.$on("updatePriceList",this.priceHandle);
            // 执行数据查询
            this.searchData();
        })
    },
    methods:{
        // 数据初始化
        init(){
            let $el=document.querySelector('.billing-wrap').parentNode;
            let offsetHeight=$el.offsetHeight;
            this.tableHeight=offsetHeight-200;
            // 清空引用
            $el=null;
            // 时间格式化
            let nowTime=this.$moment();
            nowTime=nowTime.add(2, 'minutes');
            this.end_date=nowTime.format('yyyy-MM-DD'); // 开时日期
            this.end_time=nowTime.format('HH:mm'); // 开始时间

            // 格式化结束日期和时间
            let endTime=nowTime.subtract(1, 'days');
            this.start_date= endTime.format('yyyy-MM-DD'); // 开时日期
            this.start_time=endTime.format('HH:mm'); // 开始时间

            // 当前选择时间
            this.time_range="day";

        },
        // 获取用户单价修改记录
        getPriceList(start_time,end_time,site_list,page,size){
            // 开始时间
            let start_date=this.$moment(this.start_date);
            start_date=start_date.format('yyyy-MM-DD');
            start_time=start_time||( start_date+ " "+this.start_time);
            // 结束时间
            let end_date=this.$moment(this.end_date);
            end_date=end_date.format("yyyy-MM-DD");
            end_time=end_time||(end_date+" "+this.end_time);

            // 站点列表
            site_list=site_list||this.site_list;
            page=page||this.pricepage.current;
            size=size||this.pricepage.size;

            // 进行后台请求，获取分页信息，这里的返回值都是首字母大写的形式
            // 主要原因是因为历史遗留问题，原先的老板设置的字段名都是大写字母开头的
            // 所以在进行Mybatis配置的时候，就启用了首字母大写，于是就有了现在的样子，有的是小写，有的是大写
            getPriceRecord(start_time,end_time,site_list,page,size).then(res=>{
                if(res.status&&res.status==200){
                    let content=res.content;
                    this.pricelist=content.records;
                    // 保留分页信息
                    let page={
                        current:1,
                        size:10,
                        total:0,
                    };
                    page.current=content.Current;
                    page.size=content.Size;
                    page.total=content.Total;
                    // 设置分页信息
                    this.pricepage=page;
                }
            })
        },
        
        // 获取数据库中站点及其分组信息
        getSiteGroup(){
            // 清空数据
            this.sitesList={};
            //接入接口，获取数据
            let data = this.sites_config;
            this.sites =  data;
    
            // //设置站点列表的数据
            let siteContent=data.siteList;
            this.siteList = siteContent;

            // 构建站点分组级联菜单
            let sites={};
            for(let groupid in siteContent){
                let group=siteContent[groupid];
                // 遍历站点分组
                for(let siteId in group){
                    let site=group[siteId];
                    let siteNo=site.SiteNo;
                    let t={
                        sitename:""+site.SiteName,
                        siteno:siteNo
                    }
                    sites[siteNo]=t;
                }

            }
            // 全部数组
            this.sitesList=sites;
           
            //遍历全部站点，筛选出已被选中的站点
            this.getSelectedSites(this.siteList);
        },
        // 获取选中的站点列表
        getSelectedSites(siteList){
            //遍历全部站点，筛选出已被选中的站点
            //存放选中的数据
            var selectSiteList = [];
            for (let groupId in siteList) {
                let groupSites = siteList[groupId];
                for (let siteId in groupSites) {
                    //拿到对应单个数据
                    let siteItem = groupSites[siteId];
                    if (siteItem.now == true) {
                        selectSiteList.push(siteItem);
                    }
                }
            }

            //得到选中站点的索引值
            var selectStr = "";
            for (var i = 0; i < selectSiteList.length; i++) {
                selectStr += selectSiteList[i].SiteNo + ",";
            }
            selectStr = selectStr.substr(0, selectStr.length - 1);
            // 保存选中的列表
            this.site_list = selectStr;

            // 进行数据请求
            this.searchData();
        },
        //站点选择完成之后
        siteSelectCompleted(selectedSites) {
            // 更新选中的站点数据
            this.getSelectedSites(selectedSites);
        },
        // 显示站点筛选
        showSitesSelect(){
            this.sitesDialog=true;
        },

        // 单价每页条数改变
        handlePriceSizeChange(val){
            this.getPriceList("","","",1,val);
        },
        // 单价页码改变
        handlePriceCurrentChange(val){
            this.getPriceList("","","",val,this.rechargepage.size);
        },

        // 修改单价
        rechargeTypeChange(type){
            // 显示充值对话框
            this.rechargeDialog=true;
        },

        // 时间范围事件
        timeRangeChange(val){
            // 获取当前时间
            let nowTime=this.$moment();
            let startTime=nowTime;

            // 格式化结束日期和时间
            this.end_date=nowTime.format('yyyy-MM-DD'); // 开时日期
            this.end_time=nowTime.format('HH:mm'); // 开始时间
            switch (val){
                case "day":
                startTime=nowTime.add(-1,'day');
                break;
                case "week":
                startTime=nowTime.add(-1,'week');
                break;
                case "month":
                startTime=nowTime.add(-1,'month');
                break;
                case "year":
                startTime=nowTime.add(-1,'year');
                break;
                default:
                startTime=nowTime.add(-1,'day');
                break;
            }
            this.start_date= startTime.format('yyyy-MM-DD'); // 开时日期
            this.start_time=startTime.format('HH:mm'); // 开始时间
        },
        // 时间改变
        timeChange(){
            this.time_range="customize"; // 改为自定义
        },

        // 查询数据
        searchData(){
            this.getPriceList("","","",1,this.pricepage.size);
        },
        // 统计方法
        getSummaries(param){
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if(column.property=="amount"){
                    const values = data.map(item => Number(item[column.property]));
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                }else{
                    sums[index]="";
                }
            });
            
            return sums;
        },

        // 导出文件之前，修改文件信息
        exportFile(){
            let start_date= this.$moment(this.start_date).format('yyyy-MM-DD'); // 开时日期
            let statTime=this.start_time;

            let end_date= this.$moment(this.end_date).format('yyyy-MM-DD'); // 结束日期
            let endTime=this.end_time;
            
            let fileName="单价修改记录";
            this.priceFileName=fileName+".xls";
            this.priceHeader="单价修改记录   开始时间："+start_date+" "+statTime+" 结束时间："+end_date+" "+endTime;
        },

        // 单价修改成功
        priceHandle(){
            // 时间格式化
            let nowTime=this.$moment();
            nowTime=nowTime.add(2, 'minutes'); // 比当前时间增加2分钟，防止查询不到数据
            this.end_date=nowTime.format('yyyy-MM-DD'); // 开时日期
            this.end_time=nowTime.format('HH:mm'); // 开始时间

            // 格式化结束日期和时间
            let endTime=nowTime.subtract(1, 'days');
            this.start_date= endTime.format('yyyy-MM-DD'); // 开时日期
            this.start_time=endTime.format('HH:mm'); // 开始时间

            this.time_range="customize"; // 改为自定义

            this.getPriceList("","","","","");// 获取最新的单价修改记录
            this.rechargeDialog=false; // 关闭充值对话框
        },

        // 获取用户列表
        getUserList(){
            getDatabaseUser().then(res=>{
                if(res.status&&res.status==200){
                    let users=res.content;
  
                    let userList={};
                    // 数据处理,保存用户列表信息
                    for(let user of users){
                        userList[user.WxOpenid]={
                            "WxOpenid":user.WxOpenid,
                            "UserRealName":user.UserRealName,
                            "UserCompanyBranch":user.UserCompanyBranch,
                            "UserJob":user.UserJob,
                            "UserPhone":user.UserPhone,
                            UserCompany:user.UserCompany,
                        }
                    }
                    // 触发更新
                    this.userList=userList;
                }
            });
        },

        // 检查当前时间差
        diffTimeNow(time){
            if(time){
                let timestamp=this.$moment(time).valueOf();
                let timestampNow=(new Date()).getTime();
                if(timestamp>timestampNow){
                    return true;
                }
            }
            return false;
        },

        // 取消任务
        cancelChange(item){
            let orderid=item.order_no;
            console.log(orderid);
            canelPriceChange(orderid).then(res=>{
                if(res.status&&res.status==200){
                    this.$message({
                        message:"取消成功",
                        type:"success"
                    });
                }
            })
        }
        
    }
}
</script>

<style lang="scss">
.cost-wrap{
    .el-divider__text{
        background-color: #f5f8ff;
    }

    .recharge{
        text-align:center;
        padding: 20px;

        .surplus{
            display: inline-block;
            vertical-align: middle;
            margin-right: 20px;

            > div {
                display: inline-block;
            }
            .number{
                font-size:30px;
                font-weight: 600;
            }
        }
        .rechargebtn{
            span{
                cursor: pointer;
            }
        }
    }

    .record{
         // 单元格内容居中
        .record-table{
            table td,table th{
                text-align: center !important;
            }
            .RecordTime .cell{
                word-break:initial;
                white-space: pre;
            }
        }
    }


    .pagination{
        float:right;
    }


    /**菜单栏 */
    .menu-wrap{
        background: #fff;
        padding:10px;

        /**菜单栏按钮 */
        .menu-btn {
            height: 40px;
            margin-right: 5px;
            padding: 12px;
            margin-left: 5px;

            span {
                font-size: 16px;
                font-weight: 400;
                cursor: pointer;
            }
        }
        .date-input{
        width:135px;
        input {
            width:130px;
            padding-right: 15px;
        }
        }
        .time-input{
        width:100px;
        input {
            width:90px;
            padding-right: 10px;
        }
        }
        /**时间范围 */
        .time_range{
        width:120px;
        }
        /**最大行数 */
        .maxrowcount{
        input{
            width: 100px;
            padding:0 0 0 5px;
        }

        }

        .el-form-item{
        margin-bottom: initial;
        }

        .export-excel-wrapper{
        display: inline-block;
        }

        .el-radio-button__inner{
            padding:12px;
        }
    }

}
</style>